// @flow

import axios from 'axios'
import {openWindowWithPost} from 'Shared/lib/openWindowWithPost'
import {reachGoal} from 'Shared/lib/metrika'

function proceedToCashPayment(eventBus: { $emit: Function }) {
  eventBus.$emit('openCashPaymentModal')
  reachGoal('order_payCash:begin')
  return Promise.resolve()
}

function proceedToWireTransferOrRobokassaPayment(newBillUrl) {
  window.open(newBillUrl, '_blank')
  return Promise.resolve()
}

function proceedToSbolPayment(sum: number, balance: number, eventBus: { $emit: Function }) {
  eventBus.$emit('openSbolPaymentModal', getPaymentSum(sum, balance))
  return Promise.resolve()
}

export function getPaymentSum(billSum: number, balance: number) {
  return billSum - Math.max(0, -balance)
}

export function proceedToPayment(paymentMethod: string,
                                 sum: number,
                                 balance: number,
                                 newBillUrl: string,
                                 eventBus: { $emit: Function }) {
  switch (paymentMethod) {
    case 'cash':
      return proceedToCashPayment(eventBus)
    case 'sberbank':
      return proceedToSbolPayment(sum, balance, eventBus)
    case 'robokassa':
      return axios.get(newBillUrl, sum)
        .then(({data: robokassaRequestParams}) => {
          console.log(robokassaRequestParams)
          reachGoal('order_payOnline:begin')
          return openWindowWithPost("https://auth.robokassa.ru/Merchant/Index.aspx", robokassaRequestParams)
        })
    case 'modulbank':
      reachGoal('order_payOnline:begin')
      return window.open(newBillUrl, sum)
    default:
      return proceedToWireTransferOrRobokassaPayment(newBillUrl)
  }
}

export type PaymentMethodString = 'robokassa' | 'sberbank' | 'wire_transfer' | 'cash'
